import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';  
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import * as moment from 'moment';


@Component({
  selector: 'app-tasktest',
  templateUrl: './tasktest.component.html',
  styleUrls: ['./tasktest.component.scss']
})
export class TasktestComponent implements OnInit {

  constructor(public authService: AuthService,public router:Router) { }
  idcliente;
  loading;
  tarea;
  id_tarea;
  vtarea=0;
  dettarea;
  tarea_;
  bndeditatask=0;
  notas=[];
  nota_tx=""
  bndmnugral=true;
    oculta_menu(){
      //console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      //console.log(this.bndmnugral);
    }

  dupltarea(itm){
    if(confirm("Desea dulpicar la tarea?")==false)return ;
    let postData = {
      id:itm.id
    } 
    //console.log(postData)
    this.authService.service("/api/dupl_task_tarea",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          swal.fire('¡API incorrecta! exp', '', 'success');
          this.ls_task();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });

  }
  finalizadas(){
    for(var i=0;i<this.dettarea.length;i++){
      if(this.dettarea[i].tipo==-1){
        if(this.dettarea[i].status==100){
          this.subtipos.push(this.dettarea[i]);
        }
      }
      if(this.dettarea[i].tipo>0){
        if(this.dettarea[i].status==100){
          this.total_estatus+=this.dettarea[i].status;
          this.agrupados.push(this.dettarea[i]);
        }
      }
     }
  }
  pendientes(){
    this.vtarea=2;
    this.bndcolaboradores=false
    this.ver_perfil_tareas({id_usuario:localStorage.getItem("usuario_persona"), _asignado:localStorage.getItem("nombre") });
    this.tareas_usuario(this.id_usuario);
  }
  pendientes_otro(itm){
    this.vtarea=0;
    this.bndcolaboradores=false
    //console.log("pendientes_otro")
    //console.log(itm)
    this.ver_perfil_tareas({id_usuario:itm.id_usuario, _asignado:itm._asignado });
    this.tareas_usuario(itm.id_role);
  }
  fn_nvodettarea(){

    var sfecha = "";
    var sfechaF = "";
    try {
      var dt = moment(new Date(), 'DD-MM-YYYY');
      sfecha = dt.format('YYYY') + "-" + dt.format('MM') + "-" + dt.format('DD');    

      var today = new Date();
      var tomorrow = new Date();
      tomorrow.setDate(today.getDate()+7);
      var dt1 = moment(tomorrow, 'DD-MM-YYYY');
      sfechaF = dt1.format('YYYY') + "-" + dt1.format('MM') + "-" + dt1.format('DD');    

    } catch (error) {
      sfecha = "";
      sfechaF = "";
    }


    this.task={
      area:0,
      id:0,
      id_task:this.task.id_task,
      tipo:0,
      status:0,
      nombre:"",
      prioridad:0,
      delega:0,
      asignadoa:0,
      asignadoa2:0,
      asignadoa3:0,
      fini:sfecha,
      ffin:sfechaF
    }
    this.bndeditatask=0;
  }
  id_usuario=0
  ngOnInit() {
    try{
      this.id_usuario=Number(localStorage.getItem("usuario_role"));      
      //console.log("usuario"+this.id_usuario);
    } catch (error) {
      this.id_usuario=0;
    }
    try {
      this.idcliente=localStorage.getItem("id_cliente");      
    } catch (error) {
      this.idcliente=0;
    }
    try {
      this.id_tarea=localStorage.getItem("id_tarea");
    } catch (error) {
      this.id_tarea=0;
    }
    //console.log(this.idcliente)
    this._task.id_cliente=this.idcliente;
    this._task.id_tarea=this.id_tarea;
    this.vtarea=1;
    this.ls_task();
    this.ls_task_asignado()
    this.get_org();
    this.ls_frecuentes();
    this.get_org_garoce();
    this.ver_perfil_tareas(
      {id_usuario:localStorage.getItem("usuario_persona"),
        _asignado:localStorage.getItem("nombre")
      }
    );
    
    
  }
  todas_tareas(){
    this.vtarea=1;
    this.bndcolaboradores=false
    this.tarea=this.tarea_aux;
  }
  gdanotas_task(){
    let postData={
      id:this.iddet_task,
      nota:this.nota_tx,
      id_usuario:localStorage.getItem("usuario")
     }
     //console.log(postData)
     this.authService.service("/api/gda_notasdettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(data);
           
           this.notas.push({id:0,Notas:this.nota_tx,fec_:"",usuario_:"yo"})
           this.nota_tx="";
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //console.log(di);
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  iddet_task=0;
  down_idx(){
    
  }
  up_idx(){

  }
  vedtnt_task(itm){
    this.iddet_task=itm.id
    let postData={
      id:itm.id,
      id_usuario:localStorage.getItem("usuario")
     }
     //console.log(postData)
     this.authService.service("/api/get_notasdettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(data);
           this.notas=res;       
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
       });
  }
  org_ ;
  vedt_task(itm){
    //console.log(itm)
    this.bndeditatask=1;
    //this.vtarea=3;
    this.task={
      id:itm.id,
      id_task:itm.id_task,
      area:itm.area,
      tipo:itm.tipo,
      status:itm.status,
      nombre:itm.descripcion,
      prioridad:itm.prioridad,
      delega:itm.delega,
      asignadoa:itm.asignado_a,
      asignadoa2:itm.asignado_a2,
      asignadoa3:itm.asignado_a3,
      fini:itm.fecha_ini.substring(0,10),
      ffin:itm.fecha_fin.substring(0,10)
    }
  }
  task={
    area:0,
    id:0,
    id_task:0,
    tipo:0,
    status:0,
    nombre:"",
    delega:0,
    asignadoa:0,
    asignadoa2:0,
    asignadoa3:0,
    prioridad:0,
    fini:"",
    ffin:""
  }
  edt_dettask(){
    let postData={
      task:this.task    
     }
     this.loading=true;
     //console.log(postData);
     //console.log("edi");
     this.authService.service("/api/upd_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(data);
           this.fn_vertarea({id :this.task.id_task});           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //console.log(di);
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  eli_dettask(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData={
      id:itm.id    
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/eli_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.fn_vertarea({id :this.task.id_task});              
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  gda_dettask(){
    let postData={
      task:this.task     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/ins_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           
           this.fn_vertarea({id :this.task.id_task});           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  can_task(){
    this.vtarea=2;
  }
  fn_vertarea_(itm){

  }
  id_task=0;
  pdf_tarea_(itm,i){
    this.id_task=itm.id;
    this.pdf_tarea(i);
  }

  pdf_tarea(id){
    //console.log("this.id_task")
   // console.log(id)
    localStorage.setItem("tipo",id.toString());
    localStorage.setItem("id_task",this.id_task.toString());
    this.router.navigate([]).then(result => {  window.open('#/fmttask', '_blank'); });    
  }

  total_estatus=0;
  subtipos=[]
  agrupados=[]
  org;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            //console.log(this.org);
            this.org.sort((a,b) => a.role_card.localeCompare(b.role_card));
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
    org_garoce;
    get_org_garoce(){
      let postData = {      
      }         
        this.authService.service("/api/get_equipo_garoce",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);
              this.org_garoce=data;
              //console.log("orggaroce")
              //console.log(this.org_garoce);
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta! exp', '', 'error');
            });   
      }
    config;
  fn_vertarea(itm){
    this.bndgantt=0;
    this.id_task=itm.id;
    this.task.id_task=itm.id;
    //console.log(itm);
    this.tarea_=itm.titulo
    this.vtarea=2;
    let postData={
      id_task:itm.id,     
     }
     this.loading=true;
     this.subtipos=[];
     this.agrupados=[];
     this.total_estatus=0;
     var grupos=0;
     this.authService.service("/api/get_dettask",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.dettarea=res;
           console.log(res);
           var datac=Array();
           for(var i=0;i<this.dettarea.length;i++){
            if(this.dettarea[i].tipo==-1){
              this.subtipos.push(this.dettarea[i]);
            }
            if(this.dettarea[i].tipo>0){
              this.total_estatus+=this.dettarea[i].status;
              this.agrupados.push(this.dettarea[i]);
            }
            if(this.dettarea[i].tipo==-2){
              grupos=grupos+1;
              this.total_estatus+=this.dettarea[i].status;
            }
            if(this.dettarea[i].tipo>0 || this.dettarea[i].tipo==-2){
              datac.push({
                id: this.dettarea[i].id+"-",
                name: this.dettarea[i].descripcion,
                startDate: new Date(this.dettarea[i].fecha_ini),
                endDate: new Date( this.dettarea[i].fecha_fin),
                duration: 2,
                percentComplete:  this.dettarea[i].status,
                pendingReasons: null
              });
              
              
            }
           }
           //console.log(this.agrupados.length+grupos)
           this.total_estatus=this.total_estatus/(this.agrupados.length+grupos);
          
           //console.log(datac);
           this.config = {
            columns: [
              {type: 'string', name: 'ID', field: 'id'},
              {type: 'string', name: 'Name', field: 'name'},
              {type: 'date', name: 'Start Date', field: 'startDate'},
              {type: 'date', name: 'End Date', field: 'endDate'},
              {type: 'number', name: 'Duration', field: 'duration'},
              {type: 'number', name: 'Percentage Complete', field: 'percentComplete'},
              {type: 'string', name: 'Pending Reasons', field: 'pendingReasons'}
            ], data: 
              datac
              /*
              {
                id: 'setup',
                name: 'Angular',
                startDate: new Date(2021, 2, 10),
                endDate: new Date(2021, 2, 11),
                duration: 2,
                percentComplete:  100,
                pendingReasons: null
              }, {
                id: 'Start Development',
                name: 'Login Feature',
                startDate: new Date(2021, 2, 13),
                endDate: new Date(2021, 2, 14),
                duration: 2,
                percentComplete:  0,
                pendingReasons: null
              },{
                id: 'Test',
                name: 'Test Login Feature',
                startDate: new Date(2021, 2, 16),
                endDate: new Date(2021, 2, 17),
                duration: 2,
                percentComplete:  0,
                pendingReasons: null
              }, {
                id: 'Deploy',
                name: 'Deploy to server',
                startDate: new Date(2021, 2, 18),
                endDate: new Date(2021, 2, 18),
                duration: 1,
                percentComplete:  0,
                pendingReasons: null
              }*/
            ,
            options: {
              height: 275,
              gantt: {
                criticalPathEnabled: false,
                innerGridHorizLine: {
                  stroke: '#ffe0b2',
                  strokeWidth: 2
                },
                innerGridTrack: {fill: '#fff3e0'},
                innerGridDarkTrack: {fill: '#ffcc80'}
              }
            }
          };
        

         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });




  }
  gda_task(){
    let postData = {
      task:this._task
    } 
    //console.log(postData)

    this.authService.service("/api/ins_task",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_task();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  del_task(itm){
    if(confirm("Desea elminar el registro?")==false)return ;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_task",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_task();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  bndgantt:Number=1;
  gantt(){
    this.vtarea=0;
    if(this.bndgantt==0){
      this.bndgantt=1; 
    }else{
      this.bndgantt=0;
    }
    
  }
  edt_task(){
    let postData = {
      task:this._task
    } 
    //console.log(postData)
    this.authService.service("/api/upd_task",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_task();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  fn_nvatarea(){
    this.vtarea=4;
    this.bndedita_task=0;
    var sfecha = "";
    try {
      var dt = moment(new Date(), 'DD-MM-YYYY');
      sfecha = dt.format('YYYY') + "-" + dt.format('MM') + "-" + dt.format('DD');    
    } catch (error) {
      sfecha = "";
    }
    
    this._task={
      area:0,
      id_tarea:this.id_tarea,
      id_cliente:this.idcliente,
      id:0,
      nombre:"",
      fecha:  sfecha
    }
  }
  _task={
    id_tarea:0,
    id_cliente:0,
    area:0,
    id:0,
    nombre:"",
    fecha:""
  }
  regresa_tarea(){
    this.vtarea=1;
  }
  can_dettask(){
    this.vtarea=1;
  }
  bndedita_task=0;
  vigentes_n=0;
  vencidas_n=0;
  fializadas_n=0;


  ver_vigentes(){
    this.tarea_asignada=[]
    for(var i=0;i<this.tarea_asignada_aux.length;i++){
      if(this.tarea_asignada_aux[i].vigente==1 && this.tarea_asignada_aux[i].status<100){
        this.tarea_asignada.push(this.tarea_asignada_aux[i])
      }
    }
  }
  ver_vencidas(){
    this.tarea_asignada=[]
    for(var i=0;i<this.tarea_asignada_aux.length;i++){
      if(this.tarea_asignada_aux[i].vigente!=1 && this.tarea_asignada_aux[i].status<100){
        this.tarea_asignada.push(this.tarea_asignada_aux[i])
      }
    }
  }
  ver_finalizadas(){
    this.tarea_asignada=[]
    for(var i=0;i<this.tarea_asignada_aux.length;i++){
      if(this.tarea_asignada_aux[i].status==100){
        this.tarea_asignada.push(this.tarea_asignada_aux[i])
      }
    }
  }
  ver_total(){
    this.tarea_asignada=this.tarea_asignada_aux;
  }
  tx_pendientes=""
  total_n=0;
  tarea_asignada_aux=[]
  ver_perfil_tareas(itm){
    //console.log("tareas")
    //console.log(itm)
    this.vigentes_n=0;
    this.vencidas_n=0;
    this.fializadas_n=0;
    this.total_n=0;
    this.tx_pendientes=itm._asignado
    this.vtarea=1;
    let postData={
      asignado_a:itm.id_usuario,     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/get_tareas",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(res)
           this.tarea_asignada=res;
           this.tarea_asignada_aux=res;
           this.total_n=this.tarea_asignada_aux.length;
           for(var i=0;i<this.tarea_asignada.length;i++){
              if(this.tarea_asignada[i].status==100){
                this.fializadas_n++;
              }else{
                if(this.tarea_asignada[i].vigente==1){
                  this.vigentes_n++;
                }else{
                  this.vencidas_n++;
                }
              }
              
           }
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! get_tareas', '', 'error');
       });

  }
  ver_perfil_frecuente(itm){
    //console.log(itm)
    var css='{"id_persona":'+itm.id_usuario+',"id_role":'+0+'}'
    localStorage.setItem("perfil",css);
    this.router.navigate(["/perfil"]);

  }
  bndcolaboradores=false;
  ls_frecuentes(){
    this.vtarea=1;
    let postData={
      id_cliente:this.idcliente,     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/get_contactos_frecuentes",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(res)
           this.frecuentes=res;
           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! get_contactos_frecuentes', '', 'error');
       });
  }
  frecuentes=[
              {id:33,nombre:"David",foto:"image-none.jpg"},
              {id:173,nombre:"Brenda",foto:"image-none.jpg"},
              {id:185,nombre:"Rolando",foto:"image-none.jpg"},
              {id:33,nombre:"David",foto:"image-none.jpg"},
              {id:173,nombre:"Brenda",foto:"image-none.jpg"},
              {id:185,nombre:"Rolando",foto:"image-none.jpg"},
            ]
  v_edittarea(itm){
    //console.log(itm);
    this._task={
      id_tarea:this.id_tarea,
      id_cliente:this.idcliente,
      area:Number(itm.id_role),
      id:itm.id,
      nombre:itm.titulo,
      fecha:itm.fecha.substring(0,10)
    }
    this.bndedita_task=1
  }
  tarea_aux=[];
  rea_aux;
  colaboraciones(){
    this.bndcolaboradores=true;
    this.vtarea=0;
  }
  tareas_usuario(id){
    console.log("tareas_usuario")
    console.log(this.tarea_aux)
    console.log(id)
    this.tarea=[]
    for(var i=0;i<this.tarea_aux.length;i++){
      //console.log(res[i].id_role+"::--"+this.id_usuario)
      //this.tarea.push(res[i])
     
      //if(id===this.tarea_aux[i].id_role){
        this.tarea.push(this.tarea_aux[i])
     // }
    }
  }

  ls_task(){
    this.vtarea=1;
    this.tarea=[];
    let postData={
      id_cliente:this.idcliente,     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/get_task",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(res)
           this.tarea_aux=res;
            
           this.tareas_usuario(this.id_usuario)
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  tarea_asignada;
  ls_task_asignado(){
    this.vtarea=1;
    let postData={
      asignadoa:localStorage.getItem("usuario"),     
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/get_dettask_asignado",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           //console.log(res)
           this.tarea_asignada=res;
           
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }


}
